// ================================
// SHOPTHU SHOPIFY THEME — theme.js
// ================================

document.addEventListener('DOMContentLoaded', function () {

  // ----- 1. COUNTDOWN TIMER -----
  const endTime = new Date().getTime() + (2 * 60 * 60 * 1000);
  function updateCountdown() {
    const diff = endTime - new Date().getTime();
    if (diff <= 0) return;
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const hEl = document.getElementById('st-hours');
    const mEl = document.getElementById('st-mins');
    const sEl = document.getElementById('st-secs');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ----- 2. SMOOTH SCROLL -----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ----- 3. CLOSE MOBILE MENU ON OUTSIDE CLICK -----
  document.addEventListener('click', function (e) {
    const menu = document.getElementById('stMobileMenu');
    const hamburger = document.querySelector('.hamburger');
    if (menu && hamburger && !menu.contains(e.target) && !hamburger.contains(e.target)) {
      menu.classList.remove('open');
    }
  });

  // ----- 4. AJAX ADD TO CART (optional enhancement) -----
  const addToCartForms = document.querySelectorAll('#addToCartForm');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.btn-add-cart');
      const originalText = btn.innerHTML;
      btn.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Adding...';
      btn.disabled = true;

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.innerHTML = '<i class="fa fa-check"></i> Added!';
        btn.style.background = '#388e3c';
        setTimeout(function () {
          btn.innerHTML = originalText;
          btn.disabled = false;
          btn.style.background = '';
        }, 2000);
        // Update cart count if element exists
        updateCartCount();
      })
      .catch(function () {
        btn.innerHTML = originalText;
        btn.disabled = false;
        alert('Something went wrong. Please try again.');
      });
    });
  });

  // ----- 5. UPDATE CART COUNT -----
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
      });
  }

  // AUTO SOLD COUNT (refresh-proof)
const soldCounters = document.querySelectorAll('.sold-count');

if (soldCounters.length) {

  const baseCount = 20344;

  // Date/time when counting starts
  const startTime = new Date('2026-06-11T00:00:00').getTime();

  function updateSoldCount() {

    const now = Date.now();

    // Every 15 minutes
    const intervalsPassed = Math.floor(
      (now - startTime) / (1 * 60 * 1000)
    );

    const currentCount = baseCount + (intervalsPassed * 1);

    soldCounters.forEach(counter => {
      counter.textContent = currentCount.toLocaleString() + '+';
    });
  }

  updateSoldCount();

  // Check every minute
  setInterval(updateSoldCount, 60000);
}
});
// ----- 6. MOBILE MENU TOGGLE (global) -----
function stToggleMenu() {
  const menu    = document.getElementById('stMobileMenu');
  const overlay = document.getElementById('stMenuOverlay');
  const btn     = document.getElementById('hamburger-btn');

  if (!menu) return;

  const isOpen = menu.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open', isOpen);
  if (btn)     btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

  // Prevent body scroll when menu is open
  document.body.style.overflow = isOpen ? 'hidden' : '';

  // Update aria-hidden
  menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
}

// ----- 8. FAQ ACCORDION (global) -----
function stToggleFaq(el) {
  const answer = el.nextElementSibling;
  const isOpen = el.classList.contains('open');
  document.querySelectorAll('.faq-q').forEach(function (q) { q.classList.remove('open'); });
  document.querySelectorAll('.faq-a').forEach(function (a) { a.classList.remove('open'); });
  if (!isOpen) {
    el.classList.add('open');
    answer.classList.add('open');
  }
}
